export default "__VITE_ASSET__99b196c8__"